module.exports = __webpack_public_path__ + "img/reglament.25def7b3.svg";